import React, {useState} from "react";
// @ts-ignore
import { Alert } from "reactstrap";

function AlertMessage(props: { type: string, msg: string }) {
  const [isOpen, setIsOpen] = useState(true);

  function dismiss() { setIsOpen(false); }

  return (
    <Alert className={'alertMsg'} color={props.type} isOpen={isOpen} toggle={dismiss}>
      {props.msg}
    </Alert>
  );
}

export default AlertMessage;
